module.exports = __webpack_public_path__ + "static/media/workouts.816864a5.png";